shadow$provide[177] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, compile:{enumerable:true, get:function() {
  return compile;
}}, selectAll:{enumerable:true, get:function() {
  return selectAll;
}}});
var CSSselect = require("css-select");
var require$_DOT__SLASH_css_select_adapter_DOT_js = require("./css-select-adapter.js");
var default$$require$_DOT__SLASH_css_select_adapter_DOT_js = require.esmDefault(require$_DOT__SLASH_css_select_adapter_DOT_js);
const filter = (nodes, context) => {
  const out = [];
  const contextNodes = Array.isArray(context) ? context : [context];
  const contextSet = new Set(contextNodes);
  for (const node of Array.from(nodes)) {
    let ancestor = node;
    while (ancestor != null) {
      if (contextSet.has(ancestor)) {
        out.push(node);
        break;
      }
      ancestor = default$$require$_DOT__SLASH_css_select_adapter_DOT_js.default.getParent(ancestor);
    }
  }
  return out;
};
const getRoot = element => {
  let ancestor = element;
  while (default$$require$_DOT__SLASH_css_select_adapter_DOT_js.default.getParent(ancestor) !== null) {
    ancestor = default$$require$_DOT__SLASH_css_select_adapter_DOT_js.default.getParent(ancestor);
  }
  return ancestor;
};
const selectAll = (query, context) => {
  try {
    CSSselect.compile(query);
  } catch (err) {
    return [];
  }
  const isArray = Array.isArray(context);
  if (isArray && context.length === 0) {
    return [];
  }
  const root = getRoot(isArray ? context[0] : context);
  const matches = CSSselect.selectAll(query, root, {adapter:default$$require$_DOT__SLASH_css_select_adapter_DOT_js.default});
  if (context) {
    return filter(matches, context);
  }
  return matches;
};
const compile = query => {
  try {
    return CSSselect.compile(query, {adapter:default$$require$_DOT__SLASH_css_select_adapter_DOT_js.default});
  } catch (err) {
    return () => false;
  }
};

};